export default [
  {
    path: "/supplyList",
    name: "供应列表",
    component: () => import("../views/supplyAndDemand/supply/index.vue"),
  },
  {
    path: "/demandList",
    name: "求购列表",
    component: () => import("../views/supplyAndDemand/demand/index.vue"),
  },
];
